import AbstractMessage from '@123/druid/dist/Framework/Messaging/AbstractMessage';

export default class SearchBarClosedMessage extends AbstractMessage {}
